'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _generic = require('../../helpers/generic');

require('./BlueprintModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _antd.Form.Item;
var TextArea = _antd.Input.TextArea;
var BlueprintModal = (_dec = _antd.Form.create(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(BlueprintModal, _Component);

  function BlueprintModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BlueprintModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BlueprintModal.__proto__ || (0, _getPrototypeOf2.default)(BlueprintModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      thumbnailFileList: [],
      guideFileList: [],
      aeFileList: []
    }, _this.componentWillReceiveProps = function (nextProps) {
      var visible = nextProps.visible,
          blueprint = nextProps.blueprint;


      if (!_this.props.visible && visible && blueprint) {
        _this.setState({
          thumbnailFileList: blueprint.thumbnailFileList ? blueprint.thumbnailFileList : [],
          guideFileList: blueprint.guideFileList ? blueprint.guideFileList : [],
          aeFileList: blueprint.aeFileList ? blueprint.aeFileList : []
        });
      }
    }, _this.onCancel = function () {
      _this.props.form.resetFields();
      _this.props.onCancel();
      _this.setState({
        thumbnailFileList: [],
        guideFileList: [],
        aeFileList: []
      });
    }, _this.onSubmit = function () {
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.onSubmit(values);
        }
      });
    }, _this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    }, _this.handleChange = function (fileList, key) {
      _this.setState((0, _defineProperty3.default)({}, key, fileList));
    }, _this.uploadImageView = function (type) {
      var subText = type === 'Thumbnail' ? 'This could be a brand logo or ad sample' : 'This shows the user what layers can be changed on the Blueprint';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_antd.Icon, { type: 'plus' }),
        _react2.default.createElement(
          'div',
          { className: 'ant-upload-text' },
          'Upload Blueprint ',
          type
        ),
        _react2.default.createElement(
          'div',
          { className: 'ant-upload-sub-text' },
          subText
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BlueprintModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var getFieldDecorator = this.props.form.getFieldDecorator;
      var _props = this.props,
          visible = _props.visible,
          loading = _props.loading,
          WSSEToken = _props.WSSEToken,
          mediaActionURLForThumbnails = _props.mediaActionURLForThumbnails,
          mediaActionURLForGuides = _props.mediaActionURLForGuides,
          mediaActionURLForAeFiles = _props.mediaActionURLForAeFiles;


      var submitText = this.props.blueprint ? "Submit" : "Next";
      var blueprint = this.props.blueprint || {};

      var _state = this.state,
          thumbnailFileList = _state.thumbnailFileList,
          guideFileList = _state.guideFileList,
          aeFileList = _state.aeFileList;


      return _react2.default.createElement(
        _antd.Modal,
        {
          title: 'Create Blueprint',
          visible: visible,
          closable: true,
          onCancel: loading ? null : this.onCancel,
          width: 700,
          wrapClassName: 'CreateBlueprints__Modal',
          footer: [_react2.default.createElement(
            _antd.Button,
            { disabled: loading, key: 'cancel', onClick: this.onCancel },
            'Cancel'
          ), _react2.default.createElement(
            _antd.Button,
            { loading: loading, key: 'next', onClick: this.onSubmit, type: 'primary' },
            submitText
          )]
        },
        _react2.default.createElement(
          _antd.Form,
          { layout: 'vertical' },
          _react2.default.createElement(
            _antd.Row,
            { gutter: 24 },
            _react2.default.createElement(
              _antd.Col,
              { span: 12 },
              _react2.default.createElement(
                FormItem,
                {
                  label: 'Blueprint Name'
                },
                getFieldDecorator('name', {
                  initialValue: blueprint.name || "",
                  rules: [{ required: true, message: 'Please input blueprint name' }]
                })(_react2.default.createElement(_antd.Input, { placeholder: 'Name' }))
              ),
              _react2.default.createElement(
                FormItem,
                {
                  label: 'Blueprint Type'
                },
                getFieldDecorator('type', {
                  initialValue: blueprint.type || 'VIDEO'
                })(_react2.default.createElement(
                  _antd.Radio.Group,
                  null,
                  _react2.default.createElement(
                    _antd.Radio.Button,
                    { value: 'VIDEO' },
                    'Video'
                  ),
                  _react2.default.createElement(
                    _antd.Radio.Button,
                    { value: 'IMAGE' },
                    'Image'
                  )
                ))
              ),
              _react2.default.createElement(
                FormItem,
                {
                  label: 'After Effects Package'
                },
                getFieldDecorator('aeFile', {
                  initialValue: blueprint.aeFileList || [],
                  getValueFromEvent: this.normFile
                })(_react2.default.createElement(
                  _antd.Upload,
                  {
                    accept: 'application/zip',
                    action: mediaActionURLForAeFiles,
                    customRequest: function customRequest(options) {
                      return (0, _generic.upload)(options, WSSEToken);
                    },
                    fileList: aeFileList,
                    onChange: function onChange(_ref2) {
                      var fileList = _ref2.fileList;
                      return _this2.handleChange(fileList, 'aeFileList');
                    }
                  },
                  aeFileList.length >= 1 ? null : _react2.default.createElement(
                    _antd.Button,
                    null,
                    _react2.default.createElement(_antd.Icon, { type: 'upload' }),
                    ' Click to Upload'
                  )
                ))
              ),
              _react2.default.createElement(
                FormItem,
                {
                  label: 'Description',
                  style: { marginBottom: 0 }
                },
                getFieldDecorator('description', {
                  initialValue: blueprint.description || ""
                })(_react2.default.createElement(TextArea, {
                  placeholder: 'Add any comments or instructions here',
                  autosize: { minRows: 4, maxRows: 4 }
                }))
              )
            ),
            _react2.default.createElement(
              _antd.Col,
              { span: 12 },
              _react2.default.createElement(
                _antd.Row,
                { gutter: 24 },
                _react2.default.createElement(
                  FormItem,
                  {
                    style: { marginBottom: 0 }
                  },
                  getFieldDecorator('thumbnailImage', {
                    initialValue: blueprint.thumbnailFileList || [],
                    getValueFromEvent: this.normFile
                  })(_react2.default.createElement(
                    _antd.Upload,
                    {
                      accept: 'image/*',
                      action: mediaActionURLForThumbnails,
                      customRequest: function customRequest(options) {
                        return (0, _generic.upload)(options, WSSEToken);
                      },
                      listType: 'picture-card',
                      fileList: thumbnailFileList,
                      onChange: function onChange(_ref3) {
                        var fileList = _ref3.fileList;
                        return _this2.handleChange(fileList, 'thumbnailFileList');
                      },
                      showUploadList: { showPreviewIcon: false, showRemoveIcon: true }
                    },
                    thumbnailFileList.length >= 1 ? null : this.uploadImageView('Thumbnail')
                  ))
                ),
                _react2.default.createElement(
                  FormItem,
                  {
                    style: { marginBottom: 0 }
                  },
                  getFieldDecorator('guideImage', {
                    initialValue: blueprint.guideFileList || [],
                    getValueFromEvent: this.normFile
                  })(_react2.default.createElement(
                    _antd.Upload,
                    {
                      accept: 'image/*',
                      action: mediaActionURLForGuides,
                      customRequest: function customRequest(options) {
                        return (0, _generic.upload)(options, WSSEToken);
                      },
                      listType: 'picture-card',
                      fileList: guideFileList,
                      onChange: function onChange(_ref4) {
                        var fileList = _ref4.fileList;
                        return _this2.handleChange(fileList, 'guideFileList');
                      },
                      showUploadList: { showPreviewIcon: false, showRemoveIcon: true }
                    },
                    guideFileList.length >= 1 ? null : this.uploadImageView('Guide')
                  ))
                )
              )
            )
          )
        )
      );
    }
  }]);
  return BlueprintModal;
}(_react.Component), _class2.propTypes = {
  form: _propTypes2.default.shape({
    getFieldValue: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired,
    setFieldsValue: _propTypes2.default.func.isRequired,
    setFieldsInitialValue: _propTypes2.default.func.isRequired,
    isFieldsTouched: _propTypes2.default.func.isRequired,
    validateFields: _propTypes2.default.func.isRequired,
    resetFields: _propTypes2.default.func.isRequired
  }).isRequired,
  blueprint: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    layerTemplates: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      title: _propTypes2.default.string.isRequired,
      contentType: _propTypes2.default.string.isRequired,
      validators: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
    }))
  }).isRequired,
  visible: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  onSubmit: _propTypes2.default.func.isRequired,
  mediaActionURLForThumbnails: _propTypes2.default.string.isRequired,
  mediaActionURLForGuides: _propTypes2.default.string.isRequired,
  mediaActionURLForAeFiles: _propTypes2.default.string.isRequired,
  WSSEToken: _propTypes2.default.string.isRequired
}, _temp2)) || _class);
exports.default = BlueprintModal;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/BlueprintModal/index.js
// module id = 3903
// module chunks = 5 6 7 8